var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_287_615",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_287_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.2001L8.09999 9.3001C7.91665 9.11676 7.68332 9.0251 7.39999 9.0251C7.11665 9.0251 6.88332 9.11676 6.69999 9.3001C6.51665 9.48343 6.42499 9.71676 6.42499 10.0001C6.42499 10.2834 6.51665 10.5168 6.69999 10.7001L11.3 15.3001C11.5 15.5001 11.7333 15.6001 12 15.6001C12.2667 15.6001 12.5 15.5001 12.7 15.3001L17.3 10.7001C17.4833 10.5168 17.575 10.2834 17.575 10.0001C17.575 9.71676 17.4833 9.48343 17.3 9.3001C17.1167 9.11676 16.8833 9.0251 16.6 9.0251C16.3167 9.0251 16.0833 9.11676 15.9 9.3001L12 13.2001Z",
    fill: "#5E6366"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/ICON_ARROW.72a434d408ecd9da5d44541935e281b8.svg";
export { ForwardRef as ReactComponent };